<template>
  <div class="login-box mm target-box" style="display: block">
    <div class="taget-close"></div>

    <div class="box">
      <!-- <div class="wx-login"><img src="/template/pc/skin/images/icon52.png" alt=""></div> -->

      <div class="l-menu">
        <div class="way mmdl on">邮箱登录</div>

        <div class="way dxdl">手机登录</div>
      </div>

      <div class="l-box">
        <input type="text" class="txt" id="tel" placeholder="邮箱" />

        <input type="password" class="txt" id="password" placeholder="密码" />

        <a href="javascript:;"
          ><input type="button" onclick="login()" class="btn" value="登录"
        /></a>

        <div class="ckbox">
          <div class="ck on">
            <img src="/template/pc/skin/images/icon38.png" alt="" /><img
              src="/template/pc/skin/images/icon38-1.png"
              alt=""
            />
            下次自动登录
          </div>

          <div class="other">
            <div class="wjmm wjyx">忘记密码</div>
            <div class="zczh">注册</div>
          </div>
        </div>
      </div>

      <div class="other-login">
        <div class="txt">第三方账号登录</div>

        <div class="abox">
          <a href="/index.php?m=plugins&amp;c=WxLogin&amp;a=login"
            ><img src="/template/pc/skin/images/icon53.png" alt="" /><img
              src="/template/pc/skin/images/icon53-1.png"
              alt=""
          /></a>

          <!--  <a href="javascript:;"><img src="/template/pc/skin/images/icon54.png" alt=""><img src="/template/pc/skin/images/icon54-1.png" alt=""></a>

                <a href="javascript:;"><img src="/template/pc/skin/images/icon55.png" alt=""><img src="/template/pc/skin/images/icon55-1.png" alt=""></a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>